import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { EditFormContent, BaasicButton, BasicTextArea} from 'core/components';

function PumpsNoteEditTemplate({ pumpsNoteEditViewStore }) {
    const {
        form
    } = pumpsNoteEditViewStore;

    return (
        <div className="col col-sml-12 col-lrg-8">   
            <div className="card card--form card--primary card--med">   
                <EditFormContent form={form}>
                    <div>
                    <BasicTextArea field={form.$('pumpsNote')}/>
                    <BaasicButton
                            type='submit'
                            className='btn btn--base btn--primary u-mar--top--sml'
                            label = 'Save'
                            rotate
                            icon={
                                form.submitting || form.validating
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            }
                            onClick={form.onSubmit}
                        />
                    </div>
                </EditFormContent>
            </div>
        </div>
    )
}

PumpsNoteEditTemplate.propTypes = {
    pumpsNoteEditViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PumpsNoteEditTemplate);
